import { createAsyncThunk } from "@reduxjs/toolkit";
import authApi from "../../authApi";
import { logout, setloginUserData } from "../../Slice/authSlice/loginSlice";
import { showSnackbar } from "../../Slice/snackbar/snackbarSlice";
import { setLoading } from "../../Slice/loading/loadingSlice";
export const LoginUser = createAsyncThunk(
  "create-email",
  async ({ values, navigate }, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`authenticate`, values);
      if (response?.status === 200) {
        const user = response?.data?.session_data;
        const isAuthenticated = true;
        localStorage.setItem("isAuthnticated", true);
        // localStorage.setItem("token", response?.data?.session_data?.vPassword);
        localStorage.setItem("token", response?.data?.token);
        dispatch(setloginUserData({ user, isAuthenticated }));
        navigate("/");
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "An error occurred during login.",
          type: "error",
        })
      )
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const forgetPassword = createAsyncThunk(
  "forget-password",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`resetpassword`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const signupUser = createAsyncThunk(
  "signup-user",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`saveuserProfileSignUp`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
      return error?.response?.data;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const resetPassword = createAsyncThunk(
  "savePassword",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`savePassword`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const activateAccount = createAsyncThunk(
  "activateAccount",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`activateAccount`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const activateUserProfile = createAsyncThunk(
  "activateUserProfile",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`activateUserProfile`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const jobAccept = createAsyncThunk(
  "jobAccept",
  async (request, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`jobAccept`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
      return rejectWithValue(error?.response?.data || { msg: "Job action failed." });
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const changepassword = createAsyncThunk(
  "changepassword",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`changepassword`, request);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        if(response?.data?.match !== false){
          dispatch(
            showSnackbar({
              message: response?.data?.msg,
              type: "success",
            })
          );
        }else{
          dispatch(
            showSnackbar({
              message: response?.data?.msg,
              type: "error",
            })
          );
        }
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Password is not correct!",
          type: "error",
        })
      )
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const sendMessage = createAsyncThunk(
  "sendMessage",
  async (request, { dispatch }) => {
    const {id,data} = request
    try {
      dispatch(setLoading(true));
      const response = await authApi.put(`sendMessage/${id}`, data);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Password is not correct!",
          type: "error",
        })
      )
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const sendClientMessage = createAsyncThunk(
  "sendClientMessage",
  async (request, { dispatch }) => {
    const {id,data} = request
    try {
      dispatch(setLoading(true));
      const response = await authApi.put(`sendClientMessage/${id}`, data);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Password is not correct!",
          type: "error",
        })
      )
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

// export const logoutUser = createAsyncThunk(
//     "user/logout",
//     async (request, { dispatch }) => {
//       try {
//         const response = await authApi.post("/logout", request);
//         if (response?.status === 200) {
//           localStorage.setItem("isAuthnticated", false);
//           localStorage.removeItem("role");
//           dispatch(logout());
//         //   dispatch(
//         //     showSnackbar({
//         //       message: response?.data?.status_message
//         //         ? response?.data?.status_message
//         //         : "Logout successfully",
//         //       type: "success",
//         //     })
//         //   );
//           return true;
//         }
//       } catch (error) {
//         dispatch(
//           showSnackbar({ message: error.response.data.message, type: "error" })
//         );
//         console.log("error: ", error);
//       }
//     }
//   );
